module.exports = __webpack_public_path__ + "img/facebook.d8d7cc10.svg";